// extracted by mini-css-extract-plugin
export default {"container":"flex_container__EyD+m"};